import axios from '../utils/axios';

export default function anyJobseekerLogin(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/jobseeker-admin/user/admin/superlogin', data)
    )
}